import { matchRoutes } from "react-router-dom";
import { ROUTE_DEFS, type RouteDef } from "./routeTable";

/** Every pattern a registry entry answers to: its path plus each sub-path under it. */
export function routePatterns(route: RouteDef): string[] {
	const base = route.path === "/" ? "" : route.path;
	return [route.path, ...(route.subPaths ?? []).map((sub) => `${base}/${sub}`)];
}

const TITLE_MATCHERS = ROUTE_DEFS.flatMap((route) =>
	routePatterns(route).map((path) => ({ path, title: route.title })),
);

/** What the Not-Found view (`pages/NotFound`) is titled: an address no page answers to. */
const NOT_FOUND_TITLE = "Page not found";

/** The page title for a location — a sub-path (`/admin/robots/:robotId`) carries its page's
 *  title, and an address no page answers to gets the Not-Found view's. */
export function routeTitleFor(pathname: string): string {
	const match = matchRoutes(TITLE_MATCHERS, pathname)?.[0];
	return match ? match.route.title : NOT_FOUND_TITLE;
}
